import '@/playlist/games/timeGame/styles/launch-console.scss';

import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';

import useResponsive from '@/services/hocs/useResponsive';

import Tooltip, { TooltipColors, TooltipSizes } from '@/components/tooltip/Tooltip';

import buttonConsoleAnimation from '@/playlist/games/timeGame/assets/lottie/button-console.json';

interface LaunchConsoleProps {
	onLaunch?: () => void;
	disabled?: boolean;
	isTooltipOpen?: boolean;
	isPortrait?: boolean;
}

const TOOLTIP_ANCHOR_ID = 'launch-console-tooltip';

const LaunchConsole = ({
	onLaunch,
	disabled = false,
	isTooltipOpen = false,
}: LaunchConsoleProps) => {
	const { t } = useTranslation();
	const { isPortrait, isTablet } = useResponsive();
	const lottieRef = useRef<LottieRefCurrentProps>(null);

	// Set initial position to the end of the animation
	useEffect(() => {
		if (lottieRef.current) {
			const totalFrames = lottieRef.current.getDuration(true);
			if (typeof totalFrames === 'number') {
				lottieRef.current.goToAndStop(totalFrames - 1, true);
			}
		}
	}, []);

	const handleButtonClick = () => {
		if (lottieRef.current) {
			lottieRef.current.goToAndPlay(0, true);
		}
		onLaunch?.();
	};

	return (
		<>
			<Tooltip
				place={isPortrait || isTablet ? 'left' : 'right'}
				title={t('time_game.launch_console.tooltip')}
				className="launch-console__tooltip"
				anchor={TOOLTIP_ANCHOR_ID}
				color={TooltipColors.LIGHT}
				size={TooltipSizes.LARGE}
				isOpen={isTooltipOpen}
			/>
			<div id={TOOLTIP_ANCHOR_ID} className="launch-console">
				<div className="launch-console__art">
					<Lottie
						lottieRef={lottieRef}
						animationData={buttonConsoleAnimation}
						autoplay={false}
						loop={false}
						className="launch-console__lottie"
					/>

					<button
						type="button"
						className="launch-console__button"
						onClick={handleButtonClick}
						disabled={disabled}
						aria-label="Launch"
					/>
				</div>
			</div>
		</>
	);
};

export default LaunchConsole;
